/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const dobForm = {
  FIELDS: [
    {
      type: 'datepicker',
      compProps: {
        id: 'dob',
        label: 'Select Date of Birth',
        required: true,
        errorText: 'Date of birth is required',
      },
    },
  ],
  layout: [['dob']],
  validatorConfig: {
    ruleSets: [
      {
        fields: {
          dob: [
            {
              type: 'REQUIRED',
              errorMessage: 'Please select date of birth',
            },
          ],
        },
      },
    ],
  },
};
